import React, {Component} from 'react';
import {Select} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import * as R from 'ramda';
import {codeTables} from "../../codes";

const { Option } = Select;

export class CodeMultiSelect extends Component {
  // constructor(props) {
  //   super(props);
  // }

  render() {
    const {codes, placeholder, ...props} = this.props;
    let { display } = this.props;
    if (!display) {
      display = (code) => code.name;
    }
    return (
      <Select
        showSearch
        mode='multiple'
        placeholder={placeholder || 'Please select'}
        // style={{ width: '100%' }}
        {...props}
      >
        {codes.map(code => <Option value={code.code}>{display(code)}</Option>)}
      </Select>
    );
  }
}

export class CodeMultiSelectFast extends Component {
  render() {
    const {table, placeholder, ...props} = this.props;
    let codeTable = codeTables.get(table);
    let { display } = this.props;
    if (!display) {
      display = (code) => code.name;
    }
    return (
      <Select
        showSearch
        mode='multiple'
        placeholder={placeholder || 'Please select'}
        // style={{ width: '100%' }}
        {...props}
      >
        {codeTable.map(code => <Option value={code.code}>{display(code)}</Option>)}
      </Select>
    );

  }
}



// WEBPACK FOOTER //
// ./src/components/Boilerplate/CodeMultiSelect.js